{
  "deep_search.advanced_no_suggestions": "Nessun suggerimento",
  "deep_search.advanced_no_suggestions_hint": "Digita un campo o scegli un esempio",
  "deep_search.advanced_placeholder": "Cerca documenti… es. Name:invoice Tag:invoice FileSize:>1000",
  "deep_search.attr.doc.Currency": "Valuta",
  "deep_search.attr.doc.CustomerCity": "Luogo cliente",
  "deep_search.attr.doc.CustomerCountry": "Paese cliente",
  "deep_search.attr.doc.CustomerName": "Nome cliente",
  "deep_search.attr.doc.CustomerZip": "CAP cliente",
  "deep_search.attr.doc.DocumentLanguage": "Lingua",
  "deep_search.attr.doc.DocumentTitle": "Titolo del documento",
  "deep_search.attr.doc.DocumentType": "Tipo di documento",
  "deep_search.attr.doc.DueDate": "Data di scadenza",
  "deep_search.attr.doc.InvoiceDate": "Data di fatturazione",
  "deep_search.attr.doc.InvoiceNumber": "Numero del documento",
  "deep_search.attr.doc.InvoicePeriodFrom": "Periodo da",
  "deep_search.attr.doc.InvoicePeriodTo": "Periodo a",
  "deep_search.attr.doc.PurchaseOrderNumber": "Numero dell'ordine d'acquisto",
  "deep_search.attr.doc.TotalInclVat": "Totale IVA incl.",
  "deep_search.attr.doc.VendorCity": "Luogo fornitore",
  "deep_search.attr.doc.VendorCountry": "Paese fornitore",
  "deep_search.attr.doc.VendorName": "Nome fornitore",
  "deep_search.attr.doc.VendorZip": "CAP fornitore",
  "deep_search.attr.Assignee": "Assegnatario",
  "deep_search.boolean_and_subtitle": "Require both sides",
  "deep_search.boolean_close_group": "Close group",
  "deep_search.boolean_negate": "Negate next qualifier or term",
  "deep_search.boolean_not_subtitle": "Exclude following term",
  "deep_search.boolean_open_group": "Open group",
  "deep_search.boolean_or_subtitle": "Match either side",
  "deep_search.common_apply": "Applica",
  "deep_search.common_back": "Indietro",
  "deep_search.common_save": "Salva",
  "deep_search.date_picker_bare_date_hint": "Bare dates match the whole day in the active timezone (default Europe/Zurich).",
  "deep_search.date_picker_include_time": "Includi ora",
  "deep_search.date_picker_utc": "UTC",
  "deep_search.date_picker_utc_date_only_hint": "Calendar date (UTC). Matches the whole UTC day; unaffected by tz:.",
  "deep_search.detail_clear": "Cancella",
  "deep_search.error.DANGLING_OPERATOR": "Operatore incompleto nella query ({operator})",
  "deep_search.error.DUPLICATE_SORT_KEY": "Campo di ordinamento duplicato: {key}",
  "deep_search.error.EMPTY_VALUE": "sort: richiede almeno un campo",
  "deep_search.error.INVALID_ATTRIBUTE_KEY": "Impossibile ordinare per questo attributo: {key}",
  "deep_search.error.INVALID_TIMEZONE": "Fuso orario sconosciuto: {zone}",
  "deep_search.error.INVALID_VALUE_FORMAT": "Usa una data completa (YYYY-MM-DD)",
  "deep_search.error.INVALID_WILDCARD": "I caratteri jolly all'inizio non sono supportati",
  "deep_search.error.MISPLACED_DIRECTIVE": "sort: e tz: devono essere alla fine della query",
  "deep_search.error.QUERY_TOO_COMPLEX": "Questa query è troppo complessa",
  "deep_search.error.UNBALANCED_BRACES": "Parentesi non bilanciate nella query",
  "deep_search.error.VALIDATION_ERROR": "Query di ricerca non valida",
  "deep_search.field.CreatedTime": "Creato",
  "deep_search.field.CreatedUser": "Creato da",
  "deep_search.field.FileSize": "Dimensione file",
  "deep_search.field.Kind": "Genere",
  "deep_search.field.ModifiedTime": "Modificato",
  "deep_search.field.ModifiedUser": "Modificato da",
  "deep_search.field.Name": "Nome",
  "deep_search.field.OwnerUser": "Proprietario",
  "deep_search.field.Tag": "Tag",
  "deep_search.field.Type": "Tipo",
  "deep_search.filters_all": "Tutti",
  "deep_search.filters_clear_selected": "Cancella selezione",
  "deep_search.filters_select_all": "Seleziona tutti i filtri",
  "deep_search.filters_contains_placeholder": "Contiene testo",
  "deep_search.filters_enter_value": "Inserisci {label}…",
  "deep_search.filters_find_criteria": "Trova criterio…",
  "deep_search.filters_find_sort": "Trova ordinamento…",
  "deep_search.filters_find_value": "Trova {label}…",
  "deep_search.filters_loading_options": "Caricamento opzioni…",
  "deep_search.filters_mode_date": "Data / intervallo",
  "deep_search.filters_mode_number": "Numero / intervallo",
  "deep_search.filters_mode_options": "Scegli valore",
  "deep_search.filters_mode_text": "Testo",
  "deep_search.filters_more": "Altro",
  "deep_search.filters_others": "(+ {count} altri)",
  "deep_search.filters_no_matching_criteria": "Nessun criterio corrispondente",
  "deep_search.filters_number_range": "Intervallo numerico…",
  "deep_search.filters_pick_date": "Scegli una data…",
  "deep_search.filters_pick_date_range": "Scegli un intervallo di date…",
  "deep_search.filters_sort_label": "Ordina:",
  "deep_search.filters_sort_relevance": "Rilevanza (predefinito)",
  "deep_search.filters_use_value": "Usa “{value}”",
  "deep_search.menu_all": "Tutti",
  "deep_search.menu_find": "Cerca…",
  "deep_search.menu_no_matching": "Nessuna opzione corrispondente",
  "deep_search.number_range_from": "Da",
  "deep_search.number_range_preset_0_up": "0 e oltre",
  "deep_search.number_range_preset_100_500": "100 – 500",
  "deep_search.number_range_preset_1k_5k": "1,000 – 5.000",
  "deep_search.number_range_preset_up_to_1k": "fino a 1.000",
  "deep_search.number_range_presets": "Preimpostazioni",
  "deep_search.number_range_to": "A",
  "deep_search.options_load_failed": "Impossibile caricare le opzioni del filtro",
  "deep_search.relative_14d": "14 giorni fa",
  "deep_search.relative_1h": "1 ora fa",
  "deep_search.relative_24h": "24 ore fa",
  "deep_search.relative_30d": "30 giorni fa",
  "deep_search.relative_7d": "7 giorni fa",
  "deep_search.save_dialog_cancel": "Annulla",
  "deep_search.save_dialog_confirm": "Salva",
  "deep_search.save_dialog_confirm_create": "Salva ricerca",
  "deep_search.save_dialog_edit_subtitle": "Aggiorna il nome o la vista associata. La query è mostrata come riferimento.",
  "deep_search.save_dialog_edit_title": "Modifica ricerca",
  "deep_search.save_dialog_name": "Nome ricerca",
  "deep_search.save_dialog_name_required": "Inserisci un nome",
  "deep_search.save_dialog_query": "Query",
  "deep_search.save_dialog_subtitle": "Salva la ricerca corrente per accedervi rapidamente in seguito.",
  "deep_search.save_dialog_table_options": "Colonne personalizzate",
  "deep_search.save_dialog_table_options_hint": "Questa selezione di colonne viene salvata con la ricerca. Rimuovila per usare invece le colonne della vista.",
  "deep_search.save_dialog_title": "Salva ricerca",
  "deep_search.save_dialog_variant": "Modalità di ricerca",
  "deep_search.save_dialog_view": "Vista",
  "deep_search.save_dialog_view_hint": "Rimuovi per applicare questa ricerca nella vista attualmente aperta.",
  "deep_search.sort_created_newest": "Creato (più recente)",
  "deep_search.sort_file_size_largest": "Dimensione (maggiore)",
  "deep_search.sort_modified_newest": "Modificato (più recente)",
  "deep_search.sort_modified_oldest": "Modificato (più vecchio)",
  "deep_search.sort_name_az": "Nome (A–Z)",
  "deep_search.sort_relevance": "Rilevanza",
  "deep_search.suggestion_absolute_date": "Data assoluta",
  "deep_search.suggestion_date_range": "Intervallo di date",
  "deep_search.suggestion_number_range": "Intervallo numerico",
  "deep_search.variant_advanced": "Avanzata",
  "deep_search.variant_incompatible_boolean": "Questa query usa operatori booleani — passa ad Advanced",
  "deep_search.variant_incompatible_complex": "Questa query è troppo complessa per Semplice — passa ad Advanced",
  "deep_search.variant_incompatible_grouping": "Questa query usa raggruppamento / annidamento — passa ad Advanced",
  "deep_search.variant_simple": "Semplice",
  "deep_search.location_everywhere": "Ovunque in {location}",
  "deep_search.location_current": "Corrente: {location}",
  "deep_search.location_more": "Altre posizioni…",
  "deep_search.location_select_title": "Seleziona posizione",
  "deep_search.location_clear": "Cerca nell'intera box",
  "deep_search.location_reset_default": "Ripristina posizione predefinita",
  "deep_search.table_header_location": "Posizione",
  "deep_search.search_in_location": "Cerca in \"{location}\"…",
  "deep_search.quick_show_all": "Mostra tutti i risultati",
  "deep_search.quick_no_results": "Nessun risultato",
  "deep_search.quick_modified_by": "Modificato da {user} · {when}"
}
